import { render } from "./Logements.vue?vue&type=template&id=997f2b38"
import script from "./Logements.vue?vue&type=script&lang=js"
export * from "./Logements.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__